angular.module('zc.projects')

.directive 'zcNewsletterParameterEditor', (ProjectNewsletterParameter, Meta, BaseProjectCrudEditor) ->

  class NewsletterParameterEditor extends BaseProjectCrudEditor
    link: (scope, element, attrs) ->
      # only this specific functionality
      scope.matchTypes = {}
      Meta.getNewsletterParameterMatchTypes().then (res) ->
        scope.matchTypes = res

  editor = new NewsletterParameterEditor(
    ProjectNewsletterParameter
    Meta
    '/templates/projects.settings/campaign/newsletter_parameter_editor.html'
  )

  return editor.createDirective()



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.settings/campaign/newsletter_parameter_editor.directive.coffee